import { COMPLAINT_DURATION_UNIT, CONDITION_ONSET, ROS_FINDING, ROS_SYSTEMS } from '@his/shared';
import { tr } from '@/lib/i18n-core';
import { humanize } from '@/lib/utils';

export const DIAGNOSIS_CERTAINTY = ['provisional', 'confirmed', 'differential', 'ruled_out'] as const;
export type DiagnosisCertainty = (typeof DIAGNOSIS_CERTAINTY)[number];

const SEVERITIES = ['mild', 'moderate', 'severe'] as const;

function labelled(prefix: string, value: string | null | undefined, known: readonly string[]): string {
  if (!value) return '—';
  return known.includes(value) ? tr('opd', `${prefix}${value}`) : humanize(value);
}

export function certaintyLabel(value: string | null | undefined): string {
  return labelled('dx_certainty_', value, DIAGNOSIS_CERTAINTY);
}

export function onsetLabel(value: string | null | undefined): string {
  return labelled('dx_onset_', value, CONDITION_ONSET);
}

export function durationUnitLabel(value: string | null | undefined): string {
  return labelled('duration_', value, COMPLAINT_DURATION_UNIT);
}

export function rosSystemLabel(value: string): string {
  return labelled('ros_system_', value, ROS_SYSTEMS);
}

export function rosFindingLabel(value: string): string {
  return labelled('ros_finding_', value, ROS_FINDING);
}

export function severityLabel(value: string): string {
  return labelled('', value, SEVERITIES);
}
